import React from "react";
import { Link } from "react-router-dom";

const CtaArea = () => {
  return (
    <section
      style={{
        position: "relative",
        backgroundImage:
          "url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format&fit=crop')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "5rem 0",
        isolation: "isolate",
      }}
    >
      {/* Dark overlay with blur */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.55)",
          backdropFilter: "blur(8px)",
          zIndex: 0,
        }}
      />

      <style>{`
        .cta-inner {
          position: relative;
          z-index: 1;
          text-align: center;
          max-width: 650px;
          margin: 0 auto;
        }
        .cta-inner h2 {
          font-size: 2rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        .cta-inner p {
          color: rgba(255, 255, 255, 0.9);
          font-size: 1rem;
          margin-bottom: 2rem;
        }
        .cta-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(135deg, #e86b24, #d2551a);
          color: #fff;
          font-weight: 600;
          padding: 12px 28px;
          border-radius: 50px;
          font-size: 0.95rem;
          letter-spacing: 0.3px;
          text-decoration: none;
          box-shadow: 0 8px 20px rgba(232, 107, 36, 0.35);
          transition: transform 0.3s, box-shadow 0.3s, background 0.3s;
          border: none;
          cursor: pointer;
        }
        .cta-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(232, 107, 36, 0.55);
          background: linear-gradient(135deg, #d2551a, #b8430e);
        }
      `}</style>

      <div className="cta-inner">
        <h2>Have Any Inquiry?</h2>
        <p>
          Our dedicated customer service team is on the ground and ready to
          assist you. Reach out today.
        </p>
        <Link to="/contact" className="cta-btn">
          GET IN TOUCH <i className="fas fa-arrow-right" />
        </Link>
      </div>
    </section>
  );
};

export default CtaArea;